const categorias = [
    {
        id: 1,
        codigo: 'EMBARGOS_DESMATAMENTO',
        nome: 'Embargos e desmatamento'
    },
    {
        id: 2,
        codigo: 'SOCIAL',
        nome: 'Social'
    },
    {
        id: 3,
        codigo: 'AREAS_PROTEGIDAS',
        nome: 'Áreas protegidas'
    },
    {
        id: 4,
        codigo: 'REPRESENTANTES',
        nome: 'Representantes'
    },
    {
        id: 5,
        codigo: 'EMBARGOS',
        nome: 'Embargos'
    },
    {
        id: 6,
        codigo: 'DESMATAMENTOS',
        nome: 'Desmatamentos'
    }
];

export default categorias;
